
import PublicService from "@/services/public.service";
import AdminService from "@/services/admin.service";

/**
 * @classdesc Un code de réduction pour une réservation
 * @kind class
 * @export
 * @prop {type} prop - Prop desc
 * @class MyClass
 */
export default class Code_Reduction {
  id;
  id_module;
  nom;
  type = "Pourcentage";
  valeur = 0;
  nb_utilisations = "";
  nb_utilisations_max = 0;
  date_validite = "";
  actif = 1;
  apply_to = "courses";
  /**
   * Creates an instance of Code_Reduction.
   * @constructs
   * @kind function
   * @memberof Code_Reduction
   */
  constructor() { }

  set(data) {
    for (const [key, value] of Object.entries(data)) {
      if (this.hasOwnProperty(key)) {
        this[key] = value;
      }
    }
  }

  async fetch_by_name(override_validity = false) {
    if (!this.nom || !this.id_module) return await false;
    if (this.nom == "DOSSARD OFFERT") return await false;
    if (this.nom == "MULTI PARCOURS") return await false;

    let res = await PublicService.getCodeReduction(this.nom, this.id_module, override_validity);
    if (!res) return await false;
    this.set(res);
    return await true;
  }

  async post() {
    let res = await AdminService.postCodeReduction(this);
    return res;
  }
  async remove() {
    let res = await AdminService.removeCodeReduction(this.id);
    return res;
  }
  async activate() {
    let res = await AdminService.activateCodeReduction(this.id);
    return res;
  }
  async delete() {
    let res = await AdminService.deleteCodeReduction(this.id);
    return res;
  }

  async remove_usage() {
    let res = await PublicService.removeCodeReductionUsage(this.id);
    return res;
  }

  is_remaining_usage(nb_local_usage) {
    if (this.nb_utilisations_max == 0) return true;
    return parseInt(this.nb_utilisations_max) > parseInt(nb_local_usage) + parseInt(this.nb_utilisations);
  }

  _getCartRegularPrice(cart) {
    if (!cart) return 0;
    if (cart.prix_regulier !== undefined && cart.prix_regulier !== null) {
      return parseFloat(cart.prix_regulier) || 0;
    }
    return parseFloat(cart.prix) || 0;
  }

  _getReductionableTotals(course_cart, pack_cart, options_cart, activites_cart) {
    if (!course_cart) course_cart = { nb_articles: 0, prix: 0 };
    if (!pack_cart) pack_cart = { nb_articles: 0, prix: 0 };
    if (!options_cart) options_cart = { nb_articles: 0, prix: 0 };
    if (!activites_cart) activites_cart = { nb_articles: 0, prix: 0 };

    const total_dossards_price = parseFloat(course_cart.prix || 0) + parseFloat(pack_cart.prix || 0);
    const total_options_price = parseFloat(options_cart.prix || 0) + parseFloat(activites_cart.prix || 0);
    const total_dossards_regular_price = this._getCartRegularPrice(course_cart) + this._getCartRegularPrice(pack_cart);
    const total_options_regular_price = this._getCartRegularPrice(options_cart) + this._getCartRegularPrice(activites_cart);

    if (this.apply_to == "deux") {
      return {
        actual: total_dossards_price + total_options_price,
        regular: total_dossards_regular_price + total_options_regular_price,
      };
    }
    if (this.apply_to == "courses") {
      return { actual: total_dossards_price, regular: total_dossards_regular_price };
    }
    if (this.apply_to == "options") {
      return { actual: total_options_price, regular: total_options_regular_price };
    }
    return { actual: 0, regular: 0 };
  }

  _computeDiscountAmount(actualPrice, regularPrice) {
    const actual = parseFloat(actualPrice) || 0;
    const regular = parseFloat(regularPrice) || 0;

    if (actual <= 0) {
      return 0;
    }

    if (this.type == "Pourcentage") {
      const theoreticalDiscount = regular * (parseFloat(this.valeur) / 100);
      const discount = Math.min(theoreticalDiscount, actual);
      return Math.round(discount * 100) / 100;
    }
    if (this.type == "Remise en euros") {
      return Math.min(parseFloat(this.valeur), actual);
    }
    return 0;
  }

  update_cart(course_cart, pack_cart, options_cart, activites_cart) {
    let cart = { nb_articles: 1, prix: 0 };
    const { actual, regular } = this._getReductionableTotals(course_cart, pack_cart, options_cart, activites_cart);
    const discount = this._computeDiscountAmount(actual, regular);
    cart.prix = discount > 0 ? -discount : 0;
    this.cart = cart;
    return cart;
  }

  // Comportement particulier du code de réduction STLYON15.
  // Le code de réduction ne s'applique que si la traversée Chirats 80KM est sélectionnée.
  update_cart_for_STLYON15(course_cart, list_courses) {
    let cart = { nb_articles: 1, prix: 0 };
    let traversee_chirats_selected = false;
    for (let i = 0; i < list_courses.length; i++) {
      if (list_courses[i].id == "744" && list_courses[i].selected) {
        traversee_chirats_selected = true;
        break;
      }
    }
    if (!traversee_chirats_selected || !course_cart) {
      this.cart = cart;
      return cart;
    }
    const actualPrice = parseFloat(course_cart.prix) || 0;
    const regularPrice = this._getCartRegularPrice(course_cart);
    const discount = this._computeDiscountAmount(actualPrice, regularPrice);
    cart.prix = discount > 0 ? -discount : 0;
    this.cart = cart;
    return cart;
  }


  // Comportement particulier du code de réduction STLYON25.
  // Le code de réduction ne s'applique que si la traversée Chirats 80KM est sélectionnée.
  update_cart_for_STLYON25(course_cart, list_courses) {
    let cart = { nb_articles: 1, prix: 0 };
    let traversee_chirats_selected = false;
    for (let i = 0; i < list_courses.length; i++) {
      if (list_courses[i].id == "136" && list_courses[i].selected) {
        traversee_chirats_selected = true;
        break;
      }
    }
    if (!traversee_chirats_selected || !course_cart) {
      this.cart = cart;
      return cart;
    }
    const actualPrice = parseFloat(course_cart.prix) || 0;
    const regularPrice = this._getCartRegularPrice(course_cart);
    const discount = this._computeDiscountAmount(actualPrice, regularPrice);
    cart.prix = discount > 0 ? -discount : 0;
    this.cart = cart;
    return cart;
  }

  update_cart_for_LGCHER24(course_cart) {
    let total_reductionable_price = 0;
    if (course_cart) total_reductionable_price = course_cart.prix;
    let cart = { nb_articles: 1, prix: 0 };
    if (this.type == "Remise en euros" && total_reductionable_price >= 15) {
      if (this.valeur > total_reductionable_price) {
        cart.prix = - total_reductionable_price;
      }
      else {
        cart.prix = - this.valeur;
      }
    }

    this.cart = cart;
    return cart;
  }

  // Comportement particulier du code VVX26 (aligné sur discount.service.js).
  update_cart_for_VVX26(course_cart, list_courses) {
    let cart = { nb_articles: 1, prix: 0 };
    let xgt_selected = false;
    if (list_courses) {
      for (let i = 0; i < list_courses.length; i++) {
        if ((list_courses[i].id == "1493" || list_courses[i].id == "1494") && list_courses[i].selected) {
          xgt_selected = true;
          break;
        }
      }
    }
    if (!xgt_selected || !course_cart || course_cart.prix === 0) {
      this.cart = cart;
      return cart;
    }
    const actualPrice = parseFloat(course_cart.prix) || 0;
    const regularPrice = this._getCartRegularPrice(course_cart);
    const discount = this._computeDiscountAmount(actualPrice, regularPrice);
    cart.prix = discount > 0 ? -discount : 0;
    this.cart = cart;
    return cart;
  }

  calcul_reduction(price, type_item) {
    if (type_item == 'course' && (this.apply_to == "deux" || this.apply_to == "courses")) {
      if (this.type == "Pourcentage") {
        let discount = price * (parseFloat(this.valeur) / 100);
        discount = Math.round(discount * 100) / 100;
        return parseFloat(price) - parseFloat(discount);
      }
      else if (this.type == "Remise en euros") {
        return parseFloat(price) - parseFloat(this.valeur);
      }
    }
    else if (type_item == 'option' && (this.apply_to == "deux" || this.apply_to == "options")) {
      if (this.type == "Pourcentage") {
        let discount = price * (this.valeur / 100);
        discount = Math.round(discount * 100) / 100;
        return parseFloat(price) - parseFloat(discount);
      }
      else if (this.type == "Remise en euros") {
        return parseFloat(price) - parseFloat(this.valeur);
      }
    }
    return parseFloat(price);

  }

  getSimplifiedData() {
    if (this.actif != 1) return null;
    let infos = {};
    infos.nom = this.nom;
    infos.valeur = this?.cart?.prix;
    return infos;
  }
}